import React, { useState } from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import fa from 'locales/fa.json';
import { faNumber } from 'utils/common.util';
import Card from 'components/Common/Card';
import ProfileImg from './profileImg';
import { useDispatch, useSelector } from 'react-redux';
import LoadingBox from 'components/Common/LoadingBox';
import { getSearchDataAction } from 'store/course/course.action';
import { getUserAction } from 'store/account/account.action';
import { SModal } from 'components/Account/style';
import ProfileForm from './profileForm';
import UserInfo from './userInfo';
import { getCourses, getEvents } from 'utils/profile.util';
import { TermRoute } from 'services/routes';
import TermNewCard from 'components/TermOverview/card';

const EditProfile = dynamic(() => import('./editProfile'));
const EditPassword = dynamic(() => import('../Account/editPassword'));

type ProfileType = { data: any; profile: any }; // eslint-disable-line
const Profile: React.FC<ProfileType> = ({ data, profile }) => {
  const dispatch = useDispatch();
  const query = useRouter().query.profileId;
  const error = useSelector((state) => state.course.searchDataError);
  const profileData = useSelector((state) => state.account.profile); // use for change password and mobile
  const user = useSelector((state) => state.account.user);
  const [isModalVisible, setIsModalVisible] = useState('');
  const isUser = query === 'user';
  const searchData = useSelector((state) => state.course.searchData);
  const profileCourses = getCourses(searchData?.workshops, user, query) || [];
  const profileEvents = getEvents(searchData?.events, user, query) || [];

  const reloadData = (): void => {
    dispatch(getSearchDataAction());
    dispatch(getUserAction());
  };

  return (
    <div className="duration-300 bg-gray-0 min-h-screen flex-col flex items-center justify-items-start">
      <div className="w-full xl:overflow-auto py-[20px] xl:pb-0 rounded-[8px] xl:rounded mt-[10px] xl:mt-0 xl:mb-0 md:w-[560px] relative xl:fixed right-0 bg-white xl:w-[350px] xl:h-[calc(100%-70px)]">
        <LoadingBox data={profile} error={error} reload={reloadData}>
          <div className=" items-center flex-col flex mt-[30px] md:mt-0">
            <ProfileImg image={profile?.avatar} isUser={isUser} />
            <h2
              className={`${
                isUser ? 'text-[16px]' : 'text-[20px]'
              } font-bold pt-[10px] w-[250px] flex items-center text-center justify-center`}
            >
              {profile?.nickname}
            </h2>
            {isUser ? (
              <UserInfo
                setIsModalVisible={setIsModalVisible}
                eventsCount={profileEvents?.length}
              />
            ) : (
              <div className="flex flex-col">
                <div className="flex justify-between w-[220px] text-[16px] mt-[30px]">
                  <p className="text-[16px]">{fa.global.coursesCount}</p>
                  <p>{faNumber(profileCourses?.length + profileEvents?.length)}</p>
                </div>
              </div>
            )}
          </div>
        </LoadingBox>
      </div>

      <div className="xl:pr-[370px] w-[320px] md:w-[650px] py-[20px] xl:pl-[20px]  xl:justify-self-start xl:w-full">
        {isUser && (
          <div className="font-bold text-center xl:text-right text-[24px] m-[12px] ">
            {fa.account.myTerms}
          </div>
        )}
        {isUser && (
          <div className="grid grid-cols-1 xl:grid-cols-3 gap-[16px]">
            <LoadingBox data={data && profile} error={error} reload={reloadData}>
              {user?.terms.map((card) => {
                return (
                  <TermNewCard
                    isRegistered
                    buttonTitle="برنامه هفتگی"
                    data={card as any}
                    key={card.id}
                    href={TermRoute(card.id, card.title)}
                  />
                );
              })}
            </LoadingBox>
          </div>
        )}
        <div className="font-bold text-center xl:text-right text-[24px] m-[12px] ">
          {fa.account.myWorkshops}
        </div>
        <div className="justify-center xl:justify-start flex flex-wrap">
          <LoadingBox data={data && profile} error={error} reload={reloadData}>
            {[...profileEvents, ...profileCourses]?.map((item) => (
              <div key={item.id} className="scale-[.9] m-[-15px]">
                <Card data={item} webinar={item.isWebinar} />
              </div>
            ))}
          </LoadingBox>
        </div>
      </div>

      <EditProfile
        user={user}
        visible={isModalVisible === 'info'}
        setIsModalVisible={setIsModalVisible}
      />

      <SModal
        centered
        title={null}
        footer={null}
        width={600}
        destroyOnClose
        visible={isModalVisible === 'password' || isModalVisible === 'mobile'}
        onCancel={(): void => setIsModalVisible('')}
      >
        {profileData?.next === 'ForgetPassword_step2' ? (
          <EditPassword setIsVisible={setIsModalVisible} profile />
        ) : (
          <ProfileForm profileData={profileData} setIsVisible={setIsModalVisible} />
        )}
      </SModal>
    </div>
  );
};

export default Profile;
